<template>
  <div class="main-content courses">
    <h1>Dotazníky</h1>
    <div class="heading-spliter"></div>
    <div
      class="text-mute"
    >
    Osobnostné a psychodiagnostické dotazníky vám pomôžu lepšie identifikovať svoj typ osobnosti, osobnostné predpoklady  a charakteristiky, ktoré vás vystihujú. Vďaka tomu lepšie porozumiete svojmu správaniu a reakciám v konkrétnych situáciách a tiež správaniu ostatných ľudí podľa ich charakteristík. Na základe výsledkov si budete vedieť presnejšie pomenovať vaše silné stránky, ako aj definovať rozvojové oblasti, v ktorých sa chcete zlepšiť.  
    </div>
    <h2>Aktívne dotazníky</h2>
    <div v-for="course in courses">
      <div v-if="!course.course.finished && course.course.active" class="main-content-box">
        <div class="left">
          <h3>{{course.course.lang.name}}</h3>
          <div class="text-mute">
            prebiehajúci od {{course.course.start}} do {{course.course.end}} | Dokončené:
            <span class="text-red">{{course.course.progress}}%</span>
          </div>
          <div class="text-mute">
            Odhadovaný čas vypĺňania:
            <span v-if="course.type == 1" class="text-red">15 min</span>
            <span v-if="course.type == 2" class="text-red">15 min</span>
            <span v-if="course.type == 3" class="text-red">10 min</span>
          </div>
        </div>
        <div class="right">
          <router-link
            class="button"
            :to="{name: 'questionary', params:{id: course.course.id}}"
          >Začať</router-link>
        </div>
      </div>
    </div>
    <h2>História dotazníkov</h2>
    <div v-for="course in courses">
      <div v-if="course.course.finished || !course.course.active" class="main-content-box">
        <div class="left">
          <h3>{{course.course.lang.name}}</h3>

        </div>
        <div class="right">
          <div v-if="course.type == 1 && course.course.finished && !course.course.hidden_results" class="finished">
            <div class="item">DPS: {{course.course.result.dps}}</div>
            <div class="item">SO: {{course.course.result.so}}</div>
            <div class="item">V: {{course.course.result.v}}</div>
            <div class="item">Spolu: {{course.course.result.total}}</div>
          </div>

          <div v-if="course.type == 2 && course.course.finished && !course.course.hidden_results" class="finished">
            <div class="item">A: {{course.course.result.A}}</div>
            <div class="item">R: {{course.course.result.R}}</div>
            <div class="item">T: {{course.course.result.T}}</div>
            <div class="item">P: {{course.course.result.P}}</div>
          </div>

          <div v-if="course.type == 3 && course.course.finished && !course.course.hidden_results" class="finished">
            <div
              class="item"
            >AN: {{Math.round(course.course.result.AN / course.course.result.SUM * 100)}}</div>
            <div
              class="item"
            >VO: {{Math.round(course.course.result.DR / course.course.result.SUM * 100)}}</div>
            <div
              class="item"
            >EX: {{Math.round(course.course.result.EX / course.course.result.SUM * 100)}}</div>
            <div
              class="item"
            >LA: {{Math.round(course.course.result.LA / course.course.result.SUM * 100)}}</div>
          </div>

          <div v-if="!course.course.finished && !course.course.active" class="finished">Nevyplnený!</div>

          <router-link
            v-if="course.course.finished && !course.course.hidden_results"
            class="download"
            :to="{name: 'questionary', params:{id: course.course.id}}"
          >Pozrieť výsledok</router-link>

          <router-link
            v-if="course.course.finished && course.course.hidden_results"
            class="download"
            :to="{name: 'questionary', params:{id: course.course.id}}"
          >Detail dotazníku</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  mixins: [],
  data() {
    return {
      courses: null
    };
  },
  mounted() {},
  created() {
    this.refresh();
  },
  methods: {
    refresh() {
      this.$api.server
        .post("api/public/questionary/all", {
          lang_id: this.$api.translator.getCurrent()
        })
        .then(r => {
          this.courses = r.data.courses;
        });
    }
  },
  computed: {},
  watch: {},
  validations() {}
};
</script>
<style lang="css">
  .courses .main-content-box .left {
    flex-direction: column;
    align-items: start;
  }
  main .content .main-content .main-content-box .right{
    justify-content: center !important;
  }
  .courses h3 {
    margin: 0 0 0px !important;
    }
</style>



// WEBPACK FOOTER //
// src/public_app/pages/questionary/List.vue